import { TimekeepingActionButton } from "../TimekeepingActionButton";

interface ClockOutActionProps {
  onClockOut: () => void;
}

export function ClockOutAction(props: ClockOutActionProps) {
  const { onClockOut } = props;

  return <TimekeepingActionButton title="Clock out" onClick={onClockOut} />;
}
